import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { COLOR_CODES, isMobile } from "../../common";
import { MarketDerivative } from "./market-derivative";
import { MarketDerivativeHeader } from "./MarketDerivativeHeader";
import Loading from "../../components/Loading";
import "./mobile-responsive.css";

const TABS_GROUP = [
  {
    "headline": "Derivative",
    "tabs": ["Market Analysis", "Options Analysis"]
  },
];

export function MarketDerivativePage() {
  const [tab, setTab] = useState(TABS_GROUP[0].tabs[0]);
  const navigate = useNavigate();
  const location = useLocation();
  const [dates, setDates] = useState<{
    startDate: Date;
    endDate: Date;
    key: string;
  }>({
    startDate: new Date(new Date().setDate(new Date().getDate() - 19)),
    endDate: new Date(new Date().setDate(new Date().getDate() + 1)),
    key: "selection",
  });

  useEffect(() => {
    // Set the initial tab based on the URL
    const tabFromUrl = new URLSearchParams(location.search).get("tab") as any;
    if (TABS_GROUP.flatMap((value) => value.tabs).includes(tabFromUrl)) {
      setTab(tabFromUrl);
    }
  }, []);

  useEffect(() => {
    // Update the URL whenever the tab changes
    const params = new URLSearchParams(location.search);
    params.set("tab", tab);
    navigate({ search: params.toString() }, { replace: true });
  }, [tab]);

  return (
    <div className="flex flex-col h-full w-full derivative-page">
      <MarketDerivativeHeader dates={dates} setDates={setDates} tab={tab} setTab={setTab} />
      <div
        style={{ height: "calc(100vh - 90px)" }}
        className="main-content grid grid-cols-12 gap-4 w-full px-4 p-4 md:overflow-hidden"
      >
        {tab === "Market Analysis" && (
          <MarketDerivative 
            startDate={dates.startDate.toISOString().split('T')[0]} 
            endDate={dates.endDate.toISOString().split('T')[0]} 
          />
        )}    
        {tab === "Options Analysis" && (
          <MarketDerivative 
            startDate={dates.startDate.toISOString().split('T')[0]} 
            endDate={dates.endDate.toISOString().split('T')[0]} 
          />
        )}
      </div>
      <div className="gna-footer-container">
        <div className="footer-grid grid grid-cols-3 justify-between gap-5">
          <p className="gna-footer-text">
            Data Source: <a 
              href="http://npp.gov.in" 
              target="_blank" 
              rel="noopener noreferrer"
              className="underline hover:opacity-80"
            >
              NPP
            </a>, <a 
              href="https://www.iexindia.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="underline hover:opacity-80"
            >
              IEX
            </a>, <a 
              href="https://cea.nic.in" 
              target="_blank" 
              rel="noopener noreferrer"
              className="underline hover:opacity-80"
            >
              CEA
            </a>, <a 
              href="https://grid-india.in/en/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="underline hover:opacity-80"
            >
              Grid India
            </a>
          </p>
          <p className="gna-footer-text col-span-1 text-center">
            Powered by <strong>GNA Energy</strong>
          </p>
          <strong className="gna-footer-text col-span-1 text-end">
            Beta Version
          </strong>
        </div>
      </div>
    </div>
  );
}

export function UserMenu() {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setMenuOpen(false); // Close the menu if clicked outside
      }
    }

    // Add event listener to detect clicks outside
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  function toggleMenu(event: React.MouseEvent) {
    setMenuOpen(!menuOpen)
  }

  return (
    <div className="user-menu-container" ref={menuRef}>
      {/* {!isMobile && (
        <UserIcon
          className="cursor-pointer"
          width={45}
          height={45}
          fill={COLOR_CODES.secondary}
          onClick={toggleMenu} // Use toggleMenu to handle click
        />
      )} */}
    </div>
  );
}

